import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Commons from '../../../../Services/Common/Common';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import useDelete from '../../../../hooks/useDeleteN';
import { useSave } from '../../../../hooks/useSaveN';
import { AUT_BASIC } from './index';
import {
  useDelete1,
  useSave1,
  useSearch1,
  useSearch2,
  useSearchAutR1Mutation,
  useSearchCode,
} from './AUT_BASIC_QUERY';
import { AUT_BASIC_Schema } from './AUT_BASIC_Schema';

const SCREEN_MENU_ID = 'Auth';

const AUT_BASIC_DUPLICATE_KEY_DEFS = [
  { field: 'PRO_ID', name: '프로그램ID' },
  { field: 'PRO_DTL', name: '메뉴 상세코드' },
];

const PickFieldAutDuplicate = (item, field) => {
  if (!item || field == null) return undefined;
  if (field === 'PRO_ID') return item.PRO_ID ?? item.proId;
  if (field === 'PRO_DTL') return item.PRO_DTL ?? item.proDtl;
  return item[field];
};

const BuildAutDuplicateKey = (item) =>
  JSON.stringify(
    AUT_BASIC_DUPLICATE_KEY_DEFS.map((k) =>
      (PickFieldAutDuplicate(item, k.field)?.toString().trim() ?? '')
    )
  );

const CheckDuplicateLogic1 = (dispatch, rows, changedRows) => {
  const rowKeys = new Set(rows.map(BuildAutDuplicateKey).filter(Boolean));
  const newRows = changedRows.filter((f) => f.newYn === 'Y');
  const changedKeys = newRows.map(BuildAutDuplicateKey).filter(Boolean);
  const duplicates = changedKeys.filter((k) => rowKeys.has(k));

  if (duplicates.length === 0) return true;

  const firstKey = duplicates[0];
  const exampleRow = newRows.find((f) => BuildAutDuplicateKey(f) === firstKey);
  const exampleDisplay = AUT_BASIC_DUPLICATE_KEY_DEFS.map((k) => {
    const v =
      PickFieldAutDuplicate(exampleRow, k.field)?.toString().trim() ?? '';
    return `${k.name}: '${v}'`;
  }).join(', ');

  dispatch(
    showSnackbar({
      message: `중복된 데이터가 있습니다: ${duplicates.length}건 (${exampleDisplay})`,
      type: 'warning',
    })
  );
  return false;
};

function AUT_BASICF() {
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);

  const gridRef1 = useRef();
  const gridRef2 = useRef();

  const [codeList, setCodeList] = useState([]);
  const [rowData1, setRowData1] = useState([]);
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);

  const [clickRowId, setClickRowId] = useState();

  const [modalRowData, setModalRowData] = useState([]);
  const [modalRowData2, setModalRowData2] = useState([]);
  const [selectedModalRowData, setSelectedModalRowData] = useState([]);

  const [modalToggle1, setModalToggle1] = useState(false);
  const [modalText1, setModalText1] = useState('');

  const [comboAuth, setComboAuth] = useState({
    comboList: [],
    authVal: '',
  });

  const [comboAuth2, setComboAuth2] = useState({
    comboList: [],
    authVal: '0',
  });

  const notDataLabel =
    lanInfo.length === 0
      ? ''
      : lanInfo.find((f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'NotData')
          ?.LAN_NM ?? '';

  useSearchCode({
    onSuccess: (data) => {
      const rows = Array.isArray(data) ? data : [];
      const cData = rows.filter(
        (e) =>
          (e.groupCd ?? e.GroupCd) === 'AUTH' &&
          String(e.code ?? e.Code) !== 'AUTH' &&
          String(e.code ?? e.Code) !== 'PARTNER' &&
          String(e.code ?? e.Code) !== 'DEP_MANAGER' &&
          String(e.code ?? e.Code) !== 'SITE_MANAGER'
      );
      const getComboData = cData.map((c) => ({
        value: c.code ?? c.Code,
        name: c.codeNm ?? c.CodeNm,
      }));
      const firstVal = getComboData[0]?.value ?? '';
      setComboAuth({
        comboList: getComboData,
        authVal: firstVal,
      });
      setCodeList(rows);
    },
  });

  const { refetch: RefetchAutR1 } = useSearch1({
    authCd: comboAuth.authVal,
    onErrorRow: (errRow) => {
      dispatch(
        showSnackbar({
          message: errRow?.message ?? '조회 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    },
    onSuccess: (rows) => {
      const list = rows || [];
      if (!list.length) {
        setRowData1([]);
        return;
      }
      setRowData1(Commons.InsertNumber(list));
    },
  });

  const { runAsync: RunSearchR2 } = useSearch2({
    onSuccess: (rows) => {
      const list = rows || [];
      if (!list.length) {
        setModalRowData([]);
        if (notDataLabel) {
          dispatch(
            showSnackbar({
              message: notDataLabel,
              type: 'info',
            })
          );
        }
        return;
      }
      setModalToggle1(true);
      setModalRowData(Commons.InsertNumber(list));
    },
  });

  const { runAsync: RunAutR1Copy } = useSearchAutR1Mutation({
    onSuccess: (rows) => {
      const list = rows || [];
      setModalRowData2(
        list.length ? Commons.InsertNumber(list) : []
      );
    },
  });

  const saveMutation = useSave1({
    userInfo,
    authCd: comboAuth.authVal,
  });
  const deleteMutation = useDelete1({ authCd: comboAuth.authVal });

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  const ResetLogic1 = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };

  const ResetLogic2 = () => {
    setModalRowData([]);
    setModalRowData2([]);
    setSelectedModalRowData([]);
  };

  const SearchLogic1 = async () => {
    ResetLogic1();
    ResetLogic2();
    await RefetchAutR1();
  };

  const SearchLogic2 = async () => {
    await RunSearchR2({ params: '' });
  };

  const SearchLogic3 = async (authCdVal) => {
    try {
      await RunAutR1Copy({ authCd: authCdVal, params: '' });
    } catch (e) {
      setModalRowData2([]);
      dispatch(
        showSnackbar({
          message: e?.message ?? '조회 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    }
  };

  const saveAuth = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '권한 메뉴상세',
    schema: { fields: AUT_BASIC_Schema.fields },
    getChangedRows: () => changedRowData1.filter((r) => !r.deleteYn),
    getDeletedRows: () => deletedRowData1,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: saveMutation.runAsync,
    onSuccessRefresh: async ({ saveDetailData, deleteDetailData }) => {
      await RefetchAutR1();
      const saveFail = (saveDetailData ?? []).some(
        (r) => r?.isSuccess === false
      );
      const delFail = (deleteDetailData ?? []).some(
        (r) => r?.isSuccess === false
      );
      if (saveFail || delFail) return;
      setChangedRowData1([]);
      setDeletedRowData1([]);
      setSelectedRowData1([]);
      gridRef1?.current?.api?.deselectAll?.();
    },
  });

  const SaveLogic1 = async () => {
    const changedRows = changedRowData1.filter((r) => !r.deleteYn);
    if (changedRows.length > 0) {
      const deletedNoSet = new Set((deletedRowData1 ?? []).map((r) => r.no));
      const rowDataForDuplicate = rowData1.filter(
        (r) => !deletedNoSet.has(r.no)
      );
      if (!CheckDuplicateLogic1(dispatch, rowDataForDuplicate, changedRows)) {
        return;
      }
    }
    await saveAuth.run();
  };

  const SaveLogic2 = async (_item) => {
    const items = Array.isArray(_item) ? _item : [_item];
    const rows = [];

    for (const i of items) {
      if (!i.menuId) {
        dispatch(
          showSnackbar({
            message:
              lanInfo.length === 0
                ? ''
                : lanInfo.find(
                    (f) =>
                      f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'MenuIdRequired'
                  )?.LAN_NM ?? '메뉴ID는 필수 입력입니다.',
            type: 'warning',
          })
        );
        return;
      }
      if (!i.menuDtl) {
        dispatch(
          showSnackbar({
            message:
              lanInfo.length === 0
                ? ''
                : lanInfo.find(
                    (f) =>
                      f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'MenuDtlRequired'
                  )?.LAN_NM ?? '메뉴상세코드는 필수 입력입니다.',
            type: 'warning',
          })
        );
        return;
      }
      if (comboAuth.authVal === '0' || !String(comboAuth.authVal ?? '').trim()) {
        dispatch(
          showSnackbar({
            message:
              lanInfo.length === 0
                ? ''
                : lanInfo.find(
                    (f) =>
                      f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'CheckPermission'
                  )?.LAN_NM ?? '권한을 확인하세요.',
            type: 'warning',
          })
        );
        return;
      }
      rows.push({
        PRO_ID: i.menuId,
        PRO_DTL: i.menuDtl,
        PRO_DTL_NM: i.menuDtlNm ?? '',
        SAVE_YN: i.saveYn ?? 'N',
        DELETE_YN: i.deleteYn ?? 'N',
        PRINT_YN: i.printYn ?? 'N',
      });
    }

    if (!rows.length) return;

    try {
      const result = await saveMutation.runAsync(rows);

      if (!result || result.length === 0) {
        dispatch(
          showSnackbar({
            message: '저장 후 반환된 값이 없습니다.',
            type: 'error',
          })
        );
        return;
      }

      if (result.some((r) => r.isSuccess === false)) {
        dispatch(
          showSnackbar({
            message:
              result.find((r) => r.isSuccess === false)?.message ||
              '저장 중 오류가 발생했습니다.',
            type: 'error',
          })
        );
        return;
      }

      setChangedRowData1([]);
      setSelectedRowData1([]);
      dispatch(
        showSnackbar({
          message:
            lanInfo.length === 0
              ? ''
              : lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'ItHasBeenSaved'
                )?.LAN_NM ?? '저장되었습니다.',
          type: 'success',
        })
      );
      await RefetchAutR1();
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e?.message ?? '저장 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    }
  };

  const handleAuthComboChange = (nextVal) => {
    setComboAuth((prev) => ({ ...prev, authVal: nextVal }));
    ResetLogic1();
    ResetLogic2();
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const DeleteClick1 = () => {
    const newRowExists = selectedRowData1.some((row) => row.newYn === 'Y');
    if (newRowExists) {
      NewYnErrorMsg();
      return;
    }
    deleteHandler1.MarkedForDeletion(selectedRowData1);
  };

  return (
    <div className="wrap">
      <AUT_BASIC
        gridRef1={gridRef1}
        gridRef2={gridRef2}
        codeList={codeList}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        comboAuth={comboAuth}
        setComboAuth={setComboAuth}
        comboAuth2={comboAuth2}
        setComboAuth2={setComboAuth2}
        selectedModalRowData={selectedModalRowData}
        setSelectedModalRowData={setSelectedModalRowData}
        modalRowData={modalRowData}
        modalRowData2={modalRowData2}
        setClickRowId={setClickRowId}
        clickRowId={clickRowId}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        modalText1={modalText1}
        setModalText1={setModalText1}
        SaveLogic1={SaveLogic1}
        SaveLogic2={SaveLogic2}
        SearchLogic1={SearchLogic1}
        SearchLogic2={SearchLogic2}
        SearchLogic3={SearchLogic3}
        handleAuthComboChange={handleAuthComboChange}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        RestoreRow1={deleteHandler1.RestoreRow}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        handleRowSelection1={handleRowSelection1}
        NewYnErrorMsg={NewYnErrorMsg}
        DeleteClick1={DeleteClick1}
      />
    </div>
  );
}

export default AUT_BASICF;
